import React, { Component } from 'react'

class Footer extends Component {

  render () {
    const TAG_VERSION = process.env.REACT_APP_VERSION
    return (
      <footer className='app-footer'>
        <span>© {new Date().getFullYear()}</span>
        { 
          // <a href="/terms.html" target="_blank">AGB</a> 
        }
        <a href="/imprint.html" target="_blank">Impressum</a>
        <a href="/privacy.html" target="_blank">Datenschutzerklärung</a>
        <span>{TAG_VERSION || 'v1.0.x'}</span>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js